import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import dayjs from "dayjs";
import { fetchImageAsBase64 } from "../../../../../../../utils/imageUtils";

//APP
import { imgLogo } from "../../../../../../../utils/base64-Imgs";
import { typeEstruturaAtvsExecutadas } from "./estrutura_todas_atvs";
import { HeaderDef } from "../../atvsTodas/meta/gerarPDFTodasAtivs";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

export const gerarDocDefinitionExecutadas = (
    dados: typeEstruturaAtvsExecutadas[],
    headerInfo?: HeaderDef
) => {
    const content: any[] = [];

    // Header Principal (Somente Primeira Página)
    content.push({
        stack: [
            {
                image: headerInfo?.logo || 'imgLogoAlias',
                width: 80,
                alignment: 'center',
                margin: [0, 0, 0, 10]
            },
            {
                text: `${headerInfo?.titulo || 'Relatório de Atividades Executadas'}`,
                style: 'headerMain',
                alignment: 'center',
                margin: [0, 0, 0, 10]
            },
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 760,
                        h: 4,
                        linearGradient: ['#e5f1e1', '#5da57d', '#0e743f']
                    }
                ],
            },
            {
                stack: [
                    {
                        text: `${headerInfo?.razaoSocial || ''}`,
                        fontSize: 8,
                        bold: true,
                        color: '#4D4D4D',
                        alignment: 'center'
                    },
                    ...(headerInfo?.cliente ? [{
                        margin: [0, 10, 0, 0],
                        table: {
                            widths: ['*', '30%', '30%'],
                            body: [
                                [
                                    {
                                        text: [
                                            { text: 'CLIENTE\n', fontSize: 8, color: '#7b7b7b', bold: true },
                                            { text: (headerInfo.cliente || '-').toUpperCase(), fontSize: 11, bold: true, color: '#000000' }
                                        ],
                                        alignment: 'center',
                                        margin: [5, 5, 5, 5]
                                    },
                                    {
                                        text: [
                                            { text: 'SAFRA\n', fontSize: 8, color: '#7b7b7b', bold: true },
                                            { text: (headerInfo.safra || '-').toUpperCase(), fontSize: 11, bold: true, color: '#000000' }
                                        ],
                                        alignment: 'center',
                                        margin: [5, 5, 5, 5]
                                    },
                                    {
                                        text: [
                                            { text: 'CULTURA\n', fontSize: 8, color: '#7b7b7b', bold: true },
                                            { text: (headerInfo.cultura || '-').toUpperCase(), fontSize: 11, bold: true, color: '#000000' }
                                        ],
                                        alignment: 'center',
                                        margin: [5, 5, 5, 5]
                                    }
                                ]
                            ]
                        },
                        layout: {
                            hLineWidth: () => 1,
                            vLineWidth: () => 1,
                            hLineColor: () => '#7b7b7b',
                            vLineColor: () => '#7b7b7b'
                        }
                    }] : [])
                ],
                margin: [0, 5, 0, 20]
            }
        ],
        margin: [0, 0, 0, 10]
    });

    dados.forEach((propriedade) => {
        // Header Propriedade
        content.push({
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            text: propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA",
                            style: 'headerPropriedade',
                            alignment: 'center',
                            fillColor: '#5da57d',
                            color: 'white',
                            bold: true,
                            margin: [0, 5, 0, 5]
                        }
                    ]
                ]
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 0]
        });

        propriedade.lista_atividades_por_talhao.forEach((talhao) => {
            // Header Talhao
            content.push({
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: talhao.nome_talhao || "TALHÃO NÃO INFORMADO",
                                style: 'headerTalhao',
                                alignment: 'center',
                                fillColor: '#fff',
                                color: '#165c13',
                                bold: true,
                                margin: [2, 2, 2, 2],
                                border: [true, true, true, true]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#165c13',
                    vLineColor: () => '#165c13'
                },
                margin: [0, 0, 0, 0]
            });

            talhao.lista_atividades.forEach((atv) => {

                const formatarData = (dInicio: string | null, dFim: string | null) => {
                    if (!dInicio && !dFim) return '-';
                    const i = dInicio ? dayjs(dInicio).format("DD/MM/YY") : '?';
                    const f = dFim ? dayjs(dFim).format("DD/MM/YY") : '?';
                    if (i === f) return i;
                    return `${i} | ${f}`;
                };

                const dataPlanejadaStr = formatarData(atv.data_inicio_planejada, atv.data_final_planejada);

                const isDiasNegativo = atv.dias < 0;
                const headerBgColor = isDiasNegativo ? '#e0edf8' : '#effedf';
                const headerTextColor = isDiasNegativo ? '#0958d9' : '#52c41a';

                content.push({
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                {
                                    text: `${atv.nome_atv_planejada?.toUpperCase() || "ATIVIDADE"} - (${dataPlanejadaStr})`,
                                    fontSize: 10,
                                    bold: true,
                                    color: headerTextColor,
                                    fillColor: headerBgColor,
                                    alignment: 'center',
                                    margin: [2, 4, 2, 4],
                                    border: [true, true, true, true]
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        hLineColor: () => headerTextColor,
                        vLineColor: () => headerTextColor
                    },
                    margin: [0, 0, 0, 0]
                });

                const corHeader = '#0e743f';
                const bodyExecucoes: any[] = [
                    [
                        { text: 'Pontualidade', style: 'tableHeader', alignment: 'center', fillColor: corHeader, color: 'white' },
                        { text: 'Operador', style: 'tableHeader', alignment: 'left', fillColor: corHeader, color: 'white' },
                        { text: 'Data', style: 'tableHeader', alignment: 'left', fillColor: corHeader, color: 'white' },
                        { text: 'área', style: 'tableHeader', alignment: 'left', fillColor: corHeader, color: 'white' }
                    ]
                ];

                if (!atv.lista_execucoes || atv.lista_execucoes.length === 0) {
                    bodyExecucoes.push([
                        { text: 'Nenhuma execução registrada', colSpan: 4, alignment: 'center', margin: [0, 5, 0, 5], italics: true, color: '#666' },
                        {}, {}, {}
                    ]);
                } else {
                    atv.lista_execucoes.forEach((exec) => {
                        let textPontualidade = exec.pontualidade || "Indefinido";
                        if (textPontualidade === "Adiantada") textPontualidade = "Adiantado";
                        if (textPontualidade === "Atrasada") textPontualidade = "Atrasado";

                        let colorPontualidadeText = '#000000';
                        let colorPontualidadeBg = '#ffffff';

                        if (textPontualidade === "Adiantado") {
                            colorPontualidadeText = '#cb9700'; // Dourado escuro
                            colorPontualidadeBg = '#fdf1d3'; // Dourado claro
                        } else if (textPontualidade === "Atrasado") {
                            colorPontualidadeText = '#c60b26'; // Vermelho
                            colorPontualidadeBg = '#fde5e5'; // Vermelho claro
                        } else if (textPontualidade === "No prazo") {
                            colorPontualidadeText = '#238b22'; // Verde
                            colorPontualidadeBg = '#e4f4e4'; // Verde claro
                        }

                        const dataExecStr = exec.data_final ? dayjs(exec.data_final).format("DD/MM/YYYY") : '-';

                        bodyExecucoes.push([
                            {
                                text: textPontualidade,
                                alignment: 'center',
                                bold: true,
                                margin: [0, 2, 0, 2],
                                color: colorPontualidadeText,
                                fillColor: colorPontualidadeBg
                            },
                            { text: exec.nome_usuario || '-', alignment: 'left', margin: [5, 2, 0, 2] },
                            { text: dataExecStr, alignment: 'left', margin: [5, 2, 0, 2] },
                            { text: `${exec.area} ha`, alignment: 'left', margin: [5, 2, 0, 2] }
                        ]);
                    });
                }

                content.push({
                    table: {
                        widths: ['20%', '45%', '20%', '15%'],
                        body: bodyExecucoes
                    },
                    layout: {
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        hLineColor: () => '#bfbfbf',
                        vLineColor: () => '#bfbfbf'
                    },
                    margin: [0, 0, 0, 5] //margem entre as atividades
                });
            });
        });
    });

    return {
        info: {
            title: headerInfo?.nome_arquivo || headerInfo?.titulo || 'Relatório de atividades',
            author: headerInfo?.autor || '',
        },
        content: content,
        pageOrientation: 'landscape',
        footer: (currentPage: number, pageCount: number) => {
            const dataGeracao = dayjs().format("DD/MM/YYYY, HH:mm:ss");
            return {
                stack: [
                    { text: '', margin: [0, 5, 0, 0] },
                    {
                        canvas: [
                            {
                                type: 'rect',
                                x: 0,
                                y: 0,
                                w: 760,
                                h: 4,
                                linearGradient: ['#e5f1e1', '#5da57d', '#0e743f']
                            }
                        ],
                        margin: [0, 0, 0, 5]
                    },
                    { text: '', margin: [0, 5, 0, 0] },
                    {
                        columns: [
                            {
                                width: '*',
                                stack: [
                                    {
                                        image: 'imgLogoAlias',
                                        width: 50,
                                        margin: [0, 3, 0, 0],
                                    },
                                ],
                                alignment: 'left',
                            },
                            {
                                width: '*',
                                stack: [
                                    {
                                        text: `Gerado por: ${headerInfo?.autor}`,
                                        bold: true,
                                        alignment: 'center',
                                        fontSize: 7,
                                        color: '#4D4D4D'
                                    },
                                    {
                                        text: `${dataGeracao}`,
                                        alignment: 'center',
                                        fontSize: 7,
                                        color: '#4D4D4D'
                                    },
                                ],
                                margin: [0, 3, 0, 0],
                                alignment: 'center',
                            },
                            {
                                width: '*',
                                text: `${currentPage} de ${pageCount}`,
                                alignment: 'right',
                                fontSize: 8,
                                margin: [0, 3, 0, 0],
                                color: '#4D4D4D'
                            },
                        ],
                    },
                    {
                        width: '*',
                        text: `Licenciado para: Agromarques - Consultoria Agronômica e Agricultura de Precisão 24.901.637/0001-17`,
                        alignment: 'left',
                        fontSize: 6,
                        margin: [0, 3, 0, 10],
                        color: '#4D4D4D'
                    },
                ],
                margin: [40, 0, 40, 0],
            };
        },
        images: {
            imgLogoAlias: imgLogo
        },
        styles: {
            headerMain: {
                fontSize: 20,
                bold: true,
                color: 'black'
            },
            headerPropriedade: {
                fontSize: 14,
                bold: true
            },
            headerTalhao: {
                fontSize: 12,
                bold: true
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'white',
                alignment: 'center'
            }
        },
        defaultStyle: {
            fontSize: 10,
            alignment: 'center'
        },
        pageMargins: [40, 40, 40, 60]
    };
};

export const gerarPdfAtvsExecutadasUrl = async (
    dados: typeEstruturaAtvsExecutadas[],
    headerInfo?: HeaderDef
): Promise<string> => {
    if (headerInfo?.logo && headerInfo.logo.startsWith("http")) {
        headerInfo.logo = await fetchImageAsBase64(headerInfo.logo);
    }

    return new Promise((resolve, reject) => {
        try {
            const docDefinition = gerarDocDefinitionExecutadas(dados, headerInfo);
            pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
                resolve(dataUrl);
            });
        } catch (err) {
            reject(err);
        }
    });
};

export const imprimirPdfAtvsExecutadas = async (
    dados: typeEstruturaAtvsExecutadas[],
    headerInfo?: HeaderDef
): Promise<void> => {
    if (headerInfo?.logo && headerInfo.logo.startsWith("http")) {
        headerInfo.logo = await fetchImageAsBase64(headerInfo.logo);
    }

    const docDefinition = gerarDocDefinitionExecutadas(dados, headerInfo);

    return new Promise((resolve, reject) => {
        try {
            pdfMake.createPdf(docDefinition).getBlob((blob) => {
                const blobUrl = URL.createObjectURL(blob);

                // 1. Salva o título original da página
                const originalTitle = document.title;

                // 2. Define o título temporário (usado como nome do arquivo na janela de impressão/salvamento)
                const fileTitle = headerInfo?.nome_arquivo || headerInfo?.titulo || 'Relatório';
                const tempTitle = fileTitle.replace(/[/\\?%*:|"<>]/g, '-');
                document.title = tempTitle;

                // 3. Cria um iframe oculto na página
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.top = '0';
                iframe.style.left = '0';
                iframe.style.width = '1px';
                iframe.style.height = '1px';
                iframe.style.opacity = '0.01';
                iframe.style.pointerEvents = 'none';
                iframe.style.border = 'none';
                iframe.src = blobUrl;

                document.body.appendChild(iframe);

                let cleanedUp = false;
                const cleanUp = () => {
                    if (cleanedUp) return;
                    cleanedUp = true;
                    
                    document.title = originalTitle;
                    URL.revokeObjectURL(blobUrl);
                    if (iframe.parentNode) {
                        document.body.removeChild(iframe);
                    }
                    
                    // Remove ouvintes globais para evitar vazamento
                    window.removeEventListener('afterprint', cleanUp);
                    window.removeEventListener('focus', cleanUp);
                };

                // Ouvintes para restaurar o título original apenas quando o diálogo de impressão fechar
                window.addEventListener('afterprint', cleanUp);
                window.addEventListener('focus', cleanUp);

                iframe.onload = () => {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow?.focus();
                            iframe.contentWindow?.print();
                            
                            // Resolve a Promise imediatamente após disparar a janela de impressão
                            resolve();
                        } catch (printErr) {
                            console.error("Erro ao invocar a impressão do iframe:", printErr);
                            cleanUp();
                            reject(printErr);
                        }
                    }, 500); // Pequeno atraso para garantir o carregamento do PDF no iframe
                };

                iframe.onerror = (err) => {
                    cleanUp();
                    reject(err);
                };
            });
        } catch (err) {
            reject(err);
        }
    });
};
